var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        fill: "#9BA2B6",
        height: "33",
        viewBox: "0 0 33 33",
        width: "33",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { "fill-rule": "nonzero" } }, [
        _c("path", {
          attrs: {
            d: "M21.714 20.384a.6.6 0 0 0-.599.601v4.153c0 1.66-1.343 3.01-2.993 3.01h-6.464a.6.6 0 0 0-.598.601l-.001 1.197-1.43-1.436a.599.599 0 0 0-.548-.362H5.19a3.005 3.005 0 0 1-2.994-3.01V15.87c0-1.659 1.343-3.009 2.994-3.009h6.046a.6.6 0 0 0 .599-.602.6.6 0 0 0-.599-.602H5.191C2.88 11.656 1 13.546 1 15.87v9.27c0 2.323 1.88 4.213 4.19 4.213h3.584l2.459 2.472a.597.597 0 0 0 1.022-.425l.001-2.047h5.866c2.31 0 4.19-1.89 4.19-4.214v-4.153a.6.6 0 0 0-.598-.601z",
            stroke: "#9BA2B6",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M23.088 1h-1.551c-4.914 0-8.912 3.872-8.912 8.632 0 4.759 3.998 8.631 8.912 8.631h1.551c.767 0 1.526-.094 2.262-.28l2.293 2.218a.623.623 0 0 0 .668.129.594.594 0 0 0 .378-.549v-3.436a8.775 8.775 0 0 0 2.343-2.797A8.321 8.321 0 0 0 32 9.632C32 4.872 28.002 1 23.088 1zm4.619 14.581a.588.588 0 0 0-.244.475v2.292l-1.5-1.452a.624.624 0 0 0-.614-.148c-.73.217-1.49.327-2.26.327h-1.552c-4.238 0-7.686-3.339-7.686-7.443 0-4.105 3.448-7.444 7.686-7.444h1.551c4.238 0 7.686 3.339 7.686 7.444 0 2.359-1.118 4.528-3.067 5.95z",
            stroke: "#9BA2B6",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M25.213 8.13c-.083-1.216-1.048-2.196-2.246-2.28a2.381 2.381 0 0 0-1.822.655c-.49.464-.77 1.12-.77 1.799 0 .32.256.58.572.58.316 0 .572-.26.572-.58 0-.364.144-.701.406-.95.262-.247.604-.37.964-.345.63.044 1.139.56 1.182 1.202a1.29 1.29 0 0 1-.993 1.36 1.096 1.096 0 0 0-.853 1.077v1.396c0 .32.256.581.572.581.316 0 .572-.26.572-.581v-1.35c1.153-.282 1.926-1.354 1.844-2.563zM23.14 13.736a.488.488 0 0 0-.686 0 .488.488 0 0 0 0 .685.488.488 0 0 0 .685 0 .488.488 0 0 0 0-.685zM17.85 20.375H5.462c-.324 0-.587.217-.587.484 0 .268.263.485.587.485H17.85c.325 0 .587-.217.587-.485 0-.267-.262-.484-.587-.484zM18.296 23.423a.488.488 0 0 0-.685 0 .488.488 0 0 0 0 .685.488.488 0 0 0 .685 0 .487.487 0 0 0 0-.685zM14.925 23.281H4.513c-.335 0-.607.217-.607.485 0 .267.272.484.607.484h10.412c.335 0 .606-.217.606-.484 0-.268-.271-.485-.606-.485zM13.979 16.5h-8.52c-.323 0-.584.217-.584.484 0 .268.261.485.584.485h8.52c.322 0 .584-.217.584-.485 0-.267-.262-.484-.584-.484z",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }